import 'css-chunk-1JavaScriptSource/components/svg-annotations/style.module.scss';export default {
  "annotationsWindow": "_annotationsWindow_wmzxi_1",
  "annotationsWindowHidden": "_annotationsWindowHidden_wmzxi_33"
};